export default {
    'SUPER' : 1,
    'COURSE_VOD' : 2,
    'DATUM' : 3,
    'RENCAI' : 4,
    'UNDERLINE_COURSE_SPONSOR' : 5,
    'ATLAS':6,
    'KINDERGARTEN':12
};
